import { FC, ReactElement } from 'react';

import { Customer } from '../../entities/@account/Customer/Customer';
import { Address } from '../../entities/Address/Address';
import { MyAddresses, MyData } from '../AccountDashboardConfig/subcomponents';

import './AccountData.scss';

interface AccountDataProps {
    successfullyAddedAddress?: boolean;
    customer: Customer;
    onUpdateCustomer: (newCustomerData: Customer) => void;
    onUpdateAddresses: (newAddressesData: Address) => void;
    onChangeShippingAddress: (addressId: string) => void;
    className?: string;
}

export const AccountData: FC<AccountDataProps> = ({
    successfullyAddedAddress,
    customer,
    onUpdateCustomer,
    onUpdateAddresses,
    onChangeShippingAddress,
    className = '',
}): ReactElement => (
    <div className={`account-dashboard-config ${className}`}>
        <MyData
            customer={customer}
            onSubmit={onUpdateCustomer}
        />

        <MyAddresses
            successfullyAddedAddress={successfullyAddedAddress}
            addresses={customer.addresses}
            onSubmit={onUpdateAddresses}
            onChangeShippingAddress={onChangeShippingAddress}
        />
    </div>
);
